module.exports = __webpack_public_path__ + "img/12加入我们-img2.cd310030.jpg";